import React from 'react';

import * as styled from './Image.styled';

interface IImage {
  src: string;
  alt?: string;
  width?: string;
  height?: string;
  style?: React.CSSProperties;
}

export const Image: React.FC<IImage> = ({ src, alt, width, height, style }) => (
  <styled.Image
    src={src}
    alt={alt}
    width={width}
    height={height}
    style={style}
  />
);
